import React from "react";
import steykayLogo from "../assets/logo.png";

// Standard icon wrapper with consistent stroke, size, and styling matching Tabler Icons
const IconWrapper = ({ children, size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={{ display: "block", flexShrink: 0 }}
  >
    {children}
  </svg>
);

// 1. Dashboard: 4 rounded squares in 2x2 grid
export const DashboardSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <rect x="4" y="4" width="6" height="6" rx="1.5" />
    <rect x="14" y="4" width="6" height="6" rx="1.5" />
    <rect x="4" y="14" width="6" height="6" rx="1.5" />
    <rect x="14" y="14" width="6" height="6" rx="1.5" />
  </IconWrapper>
);

// 2. Reservations: Calendar with top binder rings and divider
export const ReservationsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <rect x="4" y="5" width="16" height="16" rx="2" />
    <line x1="16" y1="3" x2="16" y2="7" />
    <line x1="8" y1="3" x2="8" y2="7" />
    <line x1="4" y1="11" x2="20" y2="11" />
  </IconWrapper>
);

// 3. Housekeeping: Cleaning bucket with sponge and handle
export const HousekeepingSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M11 9h8.995c.496 0 .744 0 .89.16c.145.16.126.413.088.917l-.621 8.23c-.132 1.752-.198 2.628-.763 3.16c-.564.533-1.426.533-3.15.533h-4.504c-1.723 0-2.585 0-3.15-.533C7.947 20.675 8.082 19.07 8 18" />
    <path d="M11 8.91v5.454c0 1.714 0 2.57-.586 3.104C9.828 18 8.886 18 7 18s-2.828 0-3.414-.532C3 16.935 3 16.078 3 14.364v-.91c0-2.57 0-3.856.879-4.655C4.757 8 6.172 8 9 8h1c.471 0 .707 0 .854.133c.146.133.146.348.146.776" />
    <path d="M19 9c0-3.866-2.25-7-5.025-7C11.443 2 9.348 4.608 9 8" />
    <path d="M3 14h8" />
    <path d="M11 13h9" />
  </IconWrapper>
);

// 4. Restaurant: Open book / menu
export const RestaurantSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
    <path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
    <line x1="3" y1="6" x2="3" y2="19" />
    <line x1="12" y1="6" x2="12" y2="19" />
    <line x1="21" y1="6" x2="21" y2="19" />
  </IconWrapper>
);

// 5. Inventory: 3D isometric cube / package box
export const InventorySidebarIcon = (props) => (
  <IconWrapper {...props}>
    <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
    <line x1="12" y1="12" x2="20" y2="7.5" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <line x1="12" y1="12" x2="4" y2="7.5" />
  </IconWrapper>
);

// 6. Staff: Multiple users / team (Tabler users)
export const StaffSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
  </IconWrapper>
);

// 7. Users: Single person outline (Tabler user)
export const UsersSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <circle cx="12" cy="7" r="4" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
  </IconWrapper>
);

// 8. Permissions: Shield with checkmark (Tabler shield-check)
export const PermissionsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
    <path d="M9 12l2 2l4 -4" />
  </IconWrapper>
);

// 9. Security: Padlock outline (Tabler lock)
export const SecuritySidebarIcon = (props) => (
  <IconWrapper {...props}>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <circle cx="12" cy="16" r="1" />
    <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
  </IconWrapper>
);

// 10. Hotel Profile: Hotel Building with arched door and 4 windows
export const HotelProfileSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M3 21h18" />
    <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
    <path d="M10 21v-4a2 2 0 0 1 4 0v4" />
    <line x1="12" y1="18" x2="12" y2="21" />
    <line x1="8.5" y1="7" x2="9.5" y2="7" />
    <line x1="14.5" y1="7" x2="15.5" y2="7" />
    <line x1="8.5" y1="11" x2="9.5" y2="11" />
    <line x1="14.5" y1="11" x2="15.5" y2="11" />
  </IconWrapper>
);

// 11. Hotels: Multi-building / skyscraper (Tabler building)
export const HotelsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <line x1="3" y1="21" x2="21" y2="21" />
    <line x1="9" y1="8" x2="10" y2="8" />
    <line x1="9" y1="12" x2="10" y2="12" />
    <line x1="9" y1="16" x2="10" y2="16" />
    <line x1="14" y1="8" x2="15" y2="8" />
    <line x1="14" y1="12" x2="15" y2="12" />
    <line x1="14" y1="16" x2="15" y2="16" />
    <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
  </IconWrapper>
);

// 12. Booking Channels: Hash / hashtag symbol (Tabler hash)
export const BookingChannelsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <line x1="5" y1="9" x2="19" y2="9" />
    <line x1="5" y1="15" x2="19" y2="15" />
    <line x1="11" y1="4" x2="7" y2="20" />
    <line x1="17" y1="4" x2="13" y2="20" />
  </IconWrapper>
);

// 13. Email Templates: Mail envelope (Tabler mail)
export const EmailTemplatesSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <polyline points="3 7 12 13 21 7" />
  </IconWrapper>
);

// 14. Taxes & Fees: Coupon / tax receipt with percent symbol (Hugeicons coupon-01)
export const TaxesFeesSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M15 8l-6 6" />
    <circle cx="9.25" cy="8.25" r=".5" fill="currentColor" />
    <circle cx="14.75" cy="13.75" r=".5" fill="currentColor" />
    <path d="M14 2H10C7.172 2 5.757 2 4.879 2.879C4 3.755 4 5.17 4 8v11.576c0 .854 0 1.28.163 1.53a1 1 0 0 0 .816.452c.298.006.66-.22 1.384-.672c.558-.349.837-.523 1.133-.6a2 2 0 0 1 1.008 0c.296.077.575.251 1.133.6l.363.226c.913.57 1.369.856 1.874.888q.126.007.252 0c.505-.032.961-.317 1.874-.888l.363-.226c.558-.349.837-.523 1.133-.6a2 2 0 0 1 1.007 0c.297.077.576.251 1.134.6c.724.452 1.086.678 1.384.672a1 1 0 0 0 .816-.452c.163-.25.163-.676.163-1.53V8c0-2.828 0-4.243-.879-5.121C18.243 2 16.828 2 14 2" />
  </IconWrapper>
);

// 15. Payment Methods: Credit card (Tabler credit-card)
export const PaymentMethodsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <rect x="3" y="5" width="18" height="14" rx="3" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <line x1="7" y1="15" x2="7.01" y2="15" />
    <line x1="11" y1="15" x2="13" y2="15" />
  </IconWrapper>
);

// 16. Room Management: Armchair / suite chair (Tabler armchair)
export const RoomManagementSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z" />
    <path d="M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5" />
    <line x1="6" y1="19" x2="6" y2="21" />
    <line x1="18" y1="19" x2="18" y2="21" />
  </IconWrapper>
);

// 17. Rates & Pricing: Coin / Discount currency symbol (Tabler coin)
export const RatesPricingSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
    <line x1="12" y1="6" x2="12" y2="8" />
    <line x1="12" y1="16" x2="12" y2="18" />
  </IconWrapper>
);

// 18. Finance: Wallet (Tabler wallet)
export const FinanceSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12" />
    <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4" />
  </IconWrapper>
);

// 19. Reports: 3-column ascending bar chart (Reports)
export const ReportsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M4 20v-5a2 2 0 0 1 2-2h3.5v-4.5a2 2 0 0 1 2-2h3.5v-3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
    <path d="M9.5 13v8" />
    <path d="M15 6.5v14.5" />
  </IconWrapper>
);

// 20. OTA / Channels: Global Network / Globe (Tabler world)
export const OtaChannelsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <circle cx="12" cy="12" r="9" />
    <line x1="3.6" y1="9" x2="20.4" y2="9" />
    <line x1="3.6" y1="15" x2="20.4" y2="15" />
    <path d="M11.5 3a17 17 0 0 0 0 18" />
    <path d="M12.5 3a17 17 0 0 1 0 18" />
  </IconWrapper>
);

// 21. Notifications: Bell (Tabler bell)
export const NotificationsSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
    <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
  </IconWrapper>
);

// 22. Logout Session: Door Exit (Tabler logout)
export const LogoutSidebarIcon = (props) => (
  <IconWrapper {...props}>
    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
    <path d="M9 12h12l-3 -3" />
    <path d="M18 15l3 -3" />
  </IconWrapper>
);

// 23. Brand Steykay Logo
export const SteykayLogoIcon = ({ size = 40, className = "" }) => (
  <img
    src={steykayLogo}
    alt="Steykay"
    width={size}
    height={size}
    className={className}
    style={{
      width: size,
      height: size,
      borderRadius: 12,
      objectFit: "cover",
      boxShadow: "0 4px 12px rgba(65, 70, 224, 0.35)",
      flexShrink: 0,
      display: "block",
    }}
  />
);
